import { createPortal } from "react-dom";
import { ReactNode } from "react";

type PortalProps = {
	children: ReactNode;
	el: string;
};

const Portal = ({ children, el }: PortalProps) => {
	const domNode = document.querySelector(el);
	return domNode ? createPortal(children, domNode) : null;
};

export default Portal;
